import AjaxUtil from 'common/Js/AjaxHelper/AjaxUtil';
import { useState, useEffect } from 'react';
const useFetch = ({ url, method = 'GET', body, headersObject }) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState();

  useEffect(() => {
    const fetchInfo = async () => {
      setLoading(true);
      try {
        const response =
          method === 'POST'
            ? await AjaxUtil.genericSendPost(url, body, headersObject)
            : await AjaxUtil.sendGet(url, headersObject);

        setResponse(response);
      } catch (error) {
        setError(error);
      }
      setLoading(false);
    };
    fetchInfo();
  }, [body, headersObject, method, url]);

  return { error, loading, response };
};
export default useFetch;
